import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class InsightsGlobalEntityGroup extends ApplicationRecord {
  static jsonapiType = "insights_global_entity_groups";

  @Attr() archived: boolean;

  @Attr() archivedAt: string;

  @Attr() name: string;
}

export default InsightsGlobalEntityGroup;
